module.exports = __webpack_public_path__ + "9395d9f83f69bff3afc865d0d73f11e8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/images/bgs/BG-halftone.png
 ** module id = 4
 ** module chunks = 0
 **/